import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../api/client'
import { useApp } from '../lib/store'

export function useAuth() {
  const { state, setAuth } = useApp()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const register = async (pin: string) => {
    setError(null)
    setLoading(true)
    try {
      const result = await api.auth.register(pin)
      setAuth(result.family_id, result.token)
      navigate('/role')
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Något gick fel')
    } finally {
      setLoading(false)
    }
  }

  const login = async (pin: string) => {
    setError(null)
    setLoading(true)
    try {
      // Single-family mode: no family_id needed, backend finds the only family
      const result = await api.auth.login(state.familyId || '', pin)
      setAuth(result.family_id, result.token)
      navigate('/role')
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Fel PIN-kod')
    } finally {
      setLoading(false)
    }
  }

  return {
    register,
    login,
    error,
    loading,
    isAuthenticated: !!state.token,
    isNewFamily: !state.familyId,
  }
}
